import * as React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";  // <-- useLocation here
import CustomModal from "./CustomModal";
import { signOut } from "firebase/auth";
import { auth } from "../../../firebase";
import { useAuth } from "../../hooks/AuthContext";
import { toast } from "react-toastify";

const menuItems = [
  { name: "Profile", route: "profile" },
  { name: "My Orders", route: "my-orders" },
  { name: "My Address", route: "my-address" },
  { name: "Logout", route: "logout" },
];

export default function AccountSideMenu({ onClose }) {
  const [open, setOpen] = React.useState(false);
  const { logout } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();  // get current path

  // Compute selected index based on current path
  const currentRoute = location.pathname.split("/").pop(); // get last segment
  const selectedIndex = menuItems.findIndex(item => item.route === currentRoute);

  const handleListItemClick = (item, index) => {
    if (item?.route === "logout") {
      setOpen(true);
    } else {
      if (onClose) onClose();
      navigate(`/account/${item?.route}`);
    }
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        localStorage.clear();
        logout();
        setOpen(false);
        toast.warning("Logged out successfully");
        navigate("/");
      })
      .catch((error) => {
        toast.error("Error logging out");
      });
  };

  return (
    <>
      <MenuShell>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: "#7A6131",
            px: 2,
            pt: 2,
            pb: 1,
          }}
        >
          Account Navigation
        </Typography>
        <List component="nav" sx={{ p: 0 }}>
          {menuItems.map((item, index) => (
            <ListItemButton
              key={index}
              selected={selectedIndex === index}
              onClick={(event) => handleListItemClick(item, index)}
              sx={{
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(255, 247, 232, 0.75)",
                },
                "&.Mui-selected": {
                  borderLeft: "4px solid var(--primary-red-base)",
                  background: "rgba(255, 250, 242, 0.95)",
                },
                boxShadow: "none",
                background: "transparent",
                borderBottom:
                  index === menuItems.length - 1
                    ? "none"
                    : "1px solid rgba(183, 124, 10, 0.12)",
                height: "64px",
                borderRadius:
                  index === 0
                    ? "14px 14px 0 0"
                    : index === menuItems.length - 1
                    ? "0 0 14px 14px"
                    : 0,
              }}
            >
              <ListItemText
                primary={item?.name}
                sx={{
                  "& .MuiListItemText-primary": {
                    fontWeight: selectedIndex === index ? 600 : 500,
                    fontSize: "16px",
                    lineHeight: "150%",
                    ml: 2,
                    color:
                      selectedIndex === index
                        ? "var(--neutral-black)"
                        : "var(--neutral-700)",
                  },
                }}
              />
            </ListItemButton>
          ))}
        </List>
        </MenuShell>
      <CustomModal
        open={open}
        setOpen={setOpen}
        title={"Logout Confirmation"}
        description={" Are you sure you want to log out?"}
        handleConfirm={handleLogout}
        confirmBtnLaebel={"Logout"}
        cancelBtnLabel={"Cancel"}
      />
    </>
  );
}

const MenuShell = styled(Box)(() => ({
  width: "100%",
  maxWidth: 300,
  minWidth: 200,
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,250,242,0.96) 100%)",
  border: "1px solid rgba(183, 124, 10, 0.22)",
  borderRadius: "14px",
  boxShadow: "0 10px 24px rgba(173, 132, 61, 0.08)",
  overflow: "hidden",
}));
